import capitalize from 'lodash/capitalize'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import React, { FC, useContext } from 'react'
import styled from 'styled-components'

import { ExtraURL, MetadataContext } from '@Globals/Metadata'
import { down } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

const RightOfWithdrawal = () => {
  const { cmsData, store } = useContext(MetadataContext)
  const { t } = useTranslation()

  if (store?.id !== '7' && store?.id !== '10') {
    return null
  }

  return (
    <span>
      <a href={`${cmsData?.urls?.terms}#6377`}>
        {t('footer:RIGHT_OF_WITHDRAWAL')}
      </a>
      {' | '}
    </span>
  )
}

const Address = () => {
  const { store } = useContext(MetadataContext)
  const { t } = useTranslation()

  if (store?.id !== '1') {
    return null
  }

  return (
    <span>
      CVR: 32261930
      {' | '}
      {t('footer:COF_ADDRESS')}
      : Egeskovvej 12, 8700 Horsens, Danmark
    </span>
  )
}

const ExtraLink: FC<ExtraURL> = ({ content, href }: ExtraURL) => (
  <span>
    <a href={href}>{content}</a>
    {' | '}
  </span>
)

const ExtraLinks = () => {
  const { infoData } = useContext(MetadataContext)

  if (isEmpty(infoData?.extraURLs)) {
    return null
  }

  return (
    <>
      {map(infoData?.extraURLs, extraURL => (
        <ExtraLink key={extraURL.href} {...extraURL} />
      ))}
    </>
  )
}

const CustomiseCookies = () => {
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)

  if (!store?.config?.usercentricsEnabled) {
    return null
  }

  return (
    <>
      {' | '}
      <button
        className="customiseCookies"
        onClick={() => (window as any).UC_UI.showSecondLayer()}
        type="button"
      >
        {t('footer:CUSTOMISE_COOKIES')}
      </button>
    </>
  )
}

const Wrapper = styled.div`
  text-align: center;
  font-size: 0.75rem;
  width: 100%;
  margin: 10px auto 0;
  padding: 0 20px;
  max-width: 700px;

  ${down('phablet')} {
    margin-top: 30px;
  }

  .customiseCookies {
    background-color: transparent;
    border: none;
    display: inline;
  }
`

export const CopyrightAndPrivacy = () => {
  const { t } = useTranslation()
  const { cmsData, store, storeURL } = useContext(MetadataContext)

  const year = new Date().getFullYear()
  const urlDomain = capitalize(store?.config?.urlDomain.replace(/^www\./, ''))
  return (
    <>
      <Wrapper>
        <a href={cmsData?.urls?.privacyPolicy}>{t('footer:PRIVACY_POLICY')}</a>
        {' | '}
        <a href={cmsData?.urls?.cookiePolicy}>{t('footer:COOKIES_POLICY')}</a>
        <CustomiseCookies />
      </Wrapper>
      <Wrapper>
        © 2009-
        {year}
        <span>
          {' | '}
          {urlDomain}
        </span>
        <span>
          {' | '}
          {t('footer:TELEPHONE_SHORT')}
          {': '}
          {store?.config?.phone}
          {' - '}
          {store?.config?.email}
        </span>
        <span>
          {' | '}
          <a href={cmsData?.urls?.terms}>{t('footer:TERMS_AND_CONDITIONS')}</a>
        </span>
        <span>
          {' | '}
          <a href={cmsData?.urls?.csr}>{t('footer:CSR_TITLE')}</a>
        </span>
        <span>
          {' | '}
          <a href={storeURL('press')}>{t('footer:PRESS_TITLE')}</a>
          {' | '}
        </span>
        <ExtraLinks />
        <RightOfWithdrawal />
        <Address />
      </Wrapper>
    </>
  )
}
